import { api } from '@src/lib/api-client';
import { QueryConfig } from '@src/lib/react-query';
import { queryOptions, useQuery } from '@tanstack/react-query';
import { ToastUtility } from '@utils';

type GetNotificationResponse = { message?: string | null };

export async function getNotification(): Promise<GetNotificationResponse> {
  const res = await api.get<GetNotificationResponse>(
    `/api/v3/user/notification`,
  );
  return res.data;
}

export const GetNotificationQueryOptions = () => {
  return queryOptions({
    queryKey: ['notification'],
    queryFn: getNotification,
    throwOnError: false,
  });
};

type UseGetNotificationOptions = {
  queryConfig?: QueryConfig<typeof GetNotificationQueryOptions>;
};

export const useGetNotification = ({
  queryConfig,
}: UseGetNotificationOptions = {}) => {
  return useQuery({ ...GetNotificationQueryOptions(), ...queryConfig });
};

export const callGetNotificationErrorToast = () =>
  ToastUtility.error('Failed to fetch Notification', {
    toastId: 'notification',
  });
